import { render, staticRenderFns } from "./SectionForm.vue?vue&type=template&id=26559c86"
import script from "./SectionForm.vue?vue&type=script&lang=ts"
export * from "./SectionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports